<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M13.001 16.001h-10a2 2 0 0 1-2-2v-12a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2zm-8-6v1.4h6v-1.4zm0-3v1.4h6v-1.4zm0-3v1.4h4v-1.4z" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-lnb-product',
});
</script>
